module.exports = __webpack_public_path__ + "static/media/Legal.c5cd295f.svg";